import React from "react";
import { Input } from "reactstrap";
import { addValidation } from "validation/ValidationWrapper";
import { InputFieldProps } from "./InputField";
import { Nullable } from "util/extendedTypes";
import { Tooltip } from "./Tooltip";

export type NumberInputProps = Omit<InputFieldProps, "value" | "onChange"> & {
  value: Nullable<number>;
  onChange: (v: number) => void;
  onBlur?: (v: number) => void;
  onFocus?: (v: number) => void;
  stopNegative?: boolean;
  stopFractional?: boolean;
  ariaDescribedBy?: string;
  ariaInvalid?: boolean;
};

export const NumberInput = ({
  name,
  value,
  disabled,
  onChange,
  onBlur = () => null,
  onFocus = () => null,
  stopFractional,
  stopNegative,
  tooltipText,
  label,
  id,
  ariaDescribedBy,
  ariaInvalid,
}: NumberInputProps) => {
  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    const keyCode = event.which || event.keyCode;
    const allowedkeys = [
      8 /* backspace */,
      9 /*tab */,
      37 /*left*/,
      39 /*right*/,
      48,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      96,
      97,
      98,
      99,
      100,
      101,
      102,
      103,
      104,
      105,
      110,
      stopFractional ? NaN : 190 /*full stop */,
      stopNegative ? NaN : 189 /*minus */,
    ];
    if (!allowedkeys.includes(keyCode)) {
      event.preventDefault();
    }
  };
  return (
    <>
      {(tooltipText || label) && (
        <label
          htmlFor={id}
          className={`inputField-header ${
            tooltipText && !label ? "inputField-header-end" : ""
          }`}
        >
          {label && <div className="inputField-label">{label}</div>}
          {tooltipText && <Tooltip id={`${id}-tooltip`} text={tooltipText} />}
        </label>
      )}
      <Input
        id={id}
        type="number"
        name={name}
        className="inputField"
        value={
          value !== null && value !== undefined && !isNaN(value) ? value : ""
        }
        disabled={disabled}
        onFocus={(e) => onFocus(parseFloat(e.target.value))}
        onChange={(e) => onChange(parseFloat(e.target.value))}
        onBlur={(e) => onBlur(parseFloat(e.target.value))}
        onKeyDown={handleKeyDown}
        aria-describedby={ariaDescribedBy}
        invalid={ariaInvalid}
      />
    </>
  );
};

export const ValidNumberInput = addValidation<
  NumberInputProps,
  Nullable<number>
>((p) => p.value)(NumberInput);
